// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import calendarCheck01Icon from "@/assets/icons/calendar-check-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type CalendarCheck01IconProps = Omit<IconProps, "name">;

export function CalendarCheck01Icon(props: CalendarCheck01IconProps): React.ReactNode {
  return <Icon name={calendarCheck01Icon} {...props} />;
}
